/* MyMysteryBox · 3D-Box-Abschnitt (02.11.2026: Handy-Entlastung)
   Echte WebGL-Box (Three.js). Die Vorderseite ist das entzerrte Foto der Original-Box; Seiten,
   Klappen und Pappe zeichnet das Skript selbst (Emblem für die Seiten aus der Vorderseite geschnitten).
   Beim Scrollen dreht sich die Box, das Klebeband reißt, die Klappen öffnen sich und goldenes Licht
   steigt auf. GSAP ScrollTrigger koppelt alles an den Scrollweg. Ohne WebGL oder bei reduzierter
   Bewegung bleibt ein ruhiger Zustand stehen. */
const THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.169.0/build/three.module.min.js';

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
async function waitForGsap() {
  for (let i = 0; i < 120; i++) {
    if (window.gsap && window.ScrollTrigger) return true;
    await sleep(50);
  }
  return false;
}

// Klebt der Header wirklich? Ein Vorfahr mit overflow ≠ visible (z. B. body am Handy) hebt "sticky" auf.
function stickyWorks(el) {
  const html = document.documentElement, body = document.body;
  const hs = getComputedStyle(html);
  const htmlVisible = hs.overflowX === 'visible' && hs.overflowY === 'visible';
  for (let p = el.parentElement; p && p !== html; p = p.parentElement) {
    const cs = getComputedStyle(p);
    if (cs.overflowX === 'visible' && cs.overflowY === 'visible') continue;
    if (cs.overflowX === 'clip' && cs.overflowY === 'clip') continue;
    if (p === body && htmlVisible) continue; // overflow des body gilt dann für das Fenster
    return false;
  }
  return true;
}
function headerOffset() {
  // Dawn: <sticky-header data-sticky-type="always|reduce-logo-size|on-scroll-up|none">
  const sh = document.querySelector('sticky-header');
  const type = sh && sh.dataset ? sh.dataset.stickyType : '';
  if (type === 'always' || type === 'reduce-logo-size') {
    const wrap = sh.closest('.shopify-section') || sh;
    if (getComputedStyle(wrap).position === 'sticky' && stickyWorks(wrap)) {
      return Math.round(wrap.getBoundingClientRect().height);
    }
  }
  return 0;
}

/* ---------- Pappe, Etikett, Klebeband als Zeichnung ---------- */
const rnd = (a, b) => a + Math.random() * (b - a);
function canvas2d(w, h) {
  const c = document.createElement('canvas');
  c.width = w; c.height = h;
  return [c, c.getContext('2d')];
}
function kraft(w, h, base, horiz = true, grain = 12) {
  const [c, g] = canvas2d(w, h);
  g.fillStyle = `rgb(${base[0]},${base[1]},${base[2]})`;
  g.fillRect(0, 0, w, h);
  // weiche Flecken
  const [n, ng] = canvas2d(14, 14);
  const id = ng.createImageData(14, 14);
  for (let i = 0; i < 196; i++) { const v = 128 + rnd(-45, 45); id.data.set([v, v, v, 255], i * 4); }
  ng.putImageData(id, 0, 0);
  g.globalCompositeOperation = 'overlay'; g.globalAlpha = 0.12; g.imageSmoothingEnabled = true;
  g.drawImage(n, 0, 0, w, h);
  // Fasern
  g.globalCompositeOperation = 'source-over';
  const count = Math.round((w * h) / 110);
  for (let i = 0; i < count; i++) {
    const x = Math.random() * w, y = Math.random() * h, len = rnd(8, 46);
    g.globalAlpha = rnd(0.03, 0.08);
    g.strokeStyle = Math.random() < 0.55 ? '#5b3b1f' : '#f2d3a6';
    g.lineWidth = rnd(0.6, 1.4);
    g.beginPath(); g.moveTo(x, y);
    if (horiz) g.lineTo(x + len, y + rnd(-1, 1)); else g.lineTo(x + rnd(-1, 1), y + len);
    g.stroke();
  }
  // Korn
  g.globalAlpha = 1;
  const d = g.getImageData(0, 0, w, h);
  for (let i = 0; i < d.data.length; i += 4) { const r = rnd(-grain, grain); d.data[i] += r; d.data[i + 1] += r; d.data[i + 2] += r * 0.8; }
  g.putImageData(d, 0, 0);
  return [c, g];
}
function edgeShade(g, w, h, px, a) {
  g.save(); g.globalCompositeOperation = 'multiply';
  const sides = [[0, 0, px, 0], [w, 0, w - px, 0], [0, 0, 0, px], [0, h, 0, h - px]];
  for (const [x0, y0, x1, y1] of sides) {
    const gr = g.createLinearGradient(x0, y0, x1, y1);
    gr.addColorStop(0, `rgba(60,35,15,${a})`); gr.addColorStop(1, 'rgba(60,35,15,0)');
    g.fillStyle = gr; g.fillRect(0, 0, w, h);
  }
  g.restore();
}
function sideTexture(front, size) {
  const KR = [188, 138, 90];
  const [c, g] = kraft(size, size, KR);
  const lx = size * 0.115, lw = size * 0.77, ly = size * 0.022, lh = size * 0.963;
  // dunkles Etikett mit roter Glut
  const bg = g.createRadialGradient(size / 2, size * 0.58, 0, size / 2, size * 0.58, size * 0.62);
  bg.addColorStop(0, '#4a0d10'); bg.addColorStop(0.55, '#1c0709'); bg.addColorStop(1, '#0b0506');
  g.fillStyle = bg; g.fillRect(lx, ly, lw, lh);
  for (let i = 0; i < 90; i++) {
    g.globalAlpha = rnd(0.25, 0.8); g.fillStyle = Math.random() < 0.7 ? '#ff7a1a' : '#ffd36b';
    g.beginPath(); g.arc(lx + Math.random() * lw, ly + lh * rnd(0.45, 1), rnd(0.6, 2.2) * size / 1024, 0, Math.PI * 2); g.fill();
  }
  g.globalAlpha = 1;
  // Emblem aus der echten Vorderseite, weich ausgeblendet
  const iw = front.naturalWidth || front.width, ih = front.naturalHeight || front.height;
  const sx = iw * 0.245, sy = ih * 0.345, sw = iw * 0.49, sh = ih * 0.55;
  const tw = lw * 0.94, th = tw * (sh / sw);
  const [e, eg] = canvas2d(Math.round(tw), Math.round(th));
  eg.drawImage(front, sx, sy, sw, sh, 0, 0, e.width, e.height);
  eg.globalCompositeOperation = 'destination-in';
  const m = eg.createRadialGradient(e.width / 2, e.height / 2, 0, e.width / 2, e.height / 2, e.width * 0.56);
  m.addColorStop(0, 'rgba(0,0,0,1)'); m.addColorStop(0.72, 'rgba(0,0,0,1)'); m.addColorStop(1, 'rgba(0,0,0,0)');
  eg.fillStyle = m; eg.fillRect(0, 0, e.width, e.height);
  g.drawImage(e, lx + (lw - tw) / 2, ly + lh * 0.5 - th * 0.52);
  edgeShade(g, size, size, size * 0.05, 0.22);
  return c;
}
function flapTexture(w, h, seamTop) {
  const [c, g] = kraft(w, h, [188, 138, 90]);
  const th = h * 0.125, y = seamTop ? 0 : h - th;
  const gr = g.createLinearGradient(0, y, 0, y + th);
  gr.addColorStop(0, seamTop ? 'rgba(255,236,200,.20)' : 'rgba(120,78,40,.20)');
  gr.addColorStop(1, seamTop ? 'rgba(120,78,40,.20)' : 'rgba(255,236,200,.20)');
  g.fillStyle = 'rgba(150,100,55,.32)'; g.fillRect(0, y, w, th);
  g.fillStyle = gr; g.fillRect(0, y, w, th);
  g.fillStyle = 'rgba(70,40,15,.35)'; g.fillRect(0, seamTop ? th - 2 : y, w, 2);
  edgeShade(g, w, h, h * 0.06, 0.18);
  return c;
}
function edgeTexture() {
  const [c, g] = kraft(256, 64, [150, 108, 70]);
  g.fillStyle = 'rgba(60,35,15,.28)';
  for (let x = 0; x < 256; x += 6) g.fillRect(x, 0, 2, 64);
  return c;
}

async function boot(root) {
  const cfg = JSON.parse(root.querySelector('.mmb3d__cfg').textContent);
  const stage = root.querySelector('.mmb3d__stage');
  const canvas = root.querySelector('.mmb3d__canvas');
  const wordA = root.querySelector('.mmb3d__word--a');
  const wordB = root.querySelector('.mmb3d__word--b');
  const cue = root.querySelector('.mmb3d__cue');
  const end = root.querySelector('.mmb3d__end');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const small = matchMedia('(max-width: 749px)').matches;
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;

  let offset = headerOffset();
  root.style.setProperty('--mmb3d-offset', offset + 'px');

  const fail = () => { root.classList.add('is-fallback', 'is-static'); };

  let THREE;
  try { THREE = await import(THREE_URL); } catch (e) { fail(); return; }

  let renderer;
  try {
    renderer = new THREE.WebGLRenderer({ canvas, antialias: !small, alpha: true, powerPreference: 'high-performance' });
  } catch (e) { fail(); return; }
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.08;
  renderer.setClearColor(0x000000, 0);

  /* ---------- Texturen ---------- */
  const frontImg = await new Promise((res) => {
    const im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = () => res(im);
    im.onerror = () => res(null);
    im.src = cfg.front;
  });
  if (!frontImg) { fail(); return; }
  const aniso = Math.min(8, renderer.capabilities.getMaxAnisotropy());
  const tex = (src, repeat) => {
    const t = src instanceof HTMLImageElement ? new THREE.Texture(src) : new THREE.CanvasTexture(src);
    t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = aniso;
    if (repeat) { t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(repeat[0], repeat[1]); }
    t.needsUpdate = true;
    return t;
  };
  const S1 = small ? 768 : 1024;
  const tFront = tex(frontImg);
  const tSide = tex(sideTexture(frontImg, S1));
  const tFlapF = tex(flapTexture(S1, Math.round(S1 * 0.45), true));
  const tFlapB = tex(flapTexture(S1, Math.round(S1 * 0.45), false));
  const tFlapS = tex(kraft(Math.round(S1 * 0.45), Math.round(S1 * 0.9), [188, 138, 90], false)[0]);
  const tInner = tex(kraft(256, 256, [176, 140, 104], true, 9)[0], [2, 2]);
  const tEdge = tex(edgeTexture(), [4, 1]);
  const [tapeC, tapeG] = canvas2d(32, 32); tapeG.fillStyle = '#a8784a'; tapeG.fillRect(0, 0, 32, 32);
  const tTape = tex(tapeC);

  const std = (map, extra = {}) => new THREE.MeshStandardMaterial({ map, roughness: 0.84, metalness: 0, ...extra });
  const mFront = std(tFront, { roughness: 0.66 });
  const mSide = std(tSide, { roughness: 0.66 });
  const mFlapF = std(tFlapF);
  const mFlapB = std(tFlapB);
  const mFlapS = std(tFlapS);
  const mInner = std(tInner, { roughness: 1, color: 0xd9c2a3 });
  const mEdge = std(tEdge, { roughness: 0.95 });
  const mTape = std(tTape, { roughness: 0.32, transparent: true, opacity: 0.9 });

  /* ---------- Szene ---------- */
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 60);

  scene.add(new THREE.HemisphereLight(0xffe7cf, 0x200606, 0.7));
  const key = new THREE.DirectionalLight(0xfff0dc, 2.7); key.position.set(-1.8, 4.4, 2.8); scene.add(key);
  if (!small) { const fill = new THREE.DirectionalLight(0xffd9b8, 0.55); fill.position.set(2.8, 1.0, 3.2); scene.add(fill); }
  const rim = new THREE.DirectionalLight(0xff2a22, 2.4); rim.position.set(1.8, 1.6, -3.6); scene.add(rim);
  if (!small) { const rim2 = new THREE.DirectionalLight(0xff4a1e, 1.3); rim2.position.set(-2.8, 0.9, -2.4); scene.add(rim2); }

  const W = 1.0, H = 0.9, D = 0.9, t = 0.014;
  const rig = new THREE.Group(); scene.add(rig);
  const box = new THREE.Group(); rig.add(box);

  const wall = (w, h, outer) => new THREE.Mesh(new THREE.BoxGeometry(w, h, t), [mEdge, mEdge, mEdge, mEdge, outer, mInner]);
  const front = wall(W, H, mFront); front.position.set(0, H / 2, D / 2 - t / 2); box.add(front);
  const back = wall(W, H, mFront); back.rotation.y = Math.PI; back.position.set(0, H / 2, -D / 2 + t / 2); box.add(back);
  const left = wall(D - 2 * t, H, mSide); left.rotation.y = -Math.PI / 2; left.position.set(-W / 2 + t / 2, H / 2, 0); box.add(left);
  const right = wall(D - 2 * t, H, mSide); right.rotation.y = Math.PI / 2; right.position.set(W / 2 - t / 2, H / 2, 0); box.add(right);
  const bottom = new THREE.Mesh(new THREE.BoxGeometry(W, t, D), [mEdge, mEdge, mInner, mEdge, mEdge, mEdge]);
  bottom.position.y = t / 2; box.add(bottom);

  // Klappen: große Klappen vorne/hinten (Naht läuft quer, wie bei der echten Box), kleine links/rechts darunter
  const flapMesh = (w, d, top) => new THREE.Mesh(new THREE.BoxGeometry(w, t, d), [mEdge, mEdge, top, mInner, mEdge, mEdge]);
  const fF = new THREE.Group(); fF.position.set(0, H, D / 2); box.add(fF);
  const fFm = flapMesh(W, D / 2, mFlapF); fFm.position.set(0, t / 2 + 0.0015, -D / 4); fF.add(fFm);
  const fB = new THREE.Group(); fB.position.set(0, H, -D / 2); box.add(fB);
  const fBm = flapMesh(W, D / 2, mFlapB); fBm.position.set(0, t / 2 + 0.0015, D / 4); fB.add(fBm);
  const L = W / 2 - 0.06;
  const fL = new THREE.Group(); fL.position.set(-W / 2, H, 0); box.add(fL);
  const fLm = flapMesh(L, D - 2 * t, mFlapS); fLm.position.set(L / 2, -t / 2, 0); fL.add(fLm);
  const fR = new THREE.Group(); fR.position.set(W / 2, H, 0); box.add(fR);
  const fRm = flapMesh(L, D - 2 * t, mFlapS); fRm.position.set(-L / 2, -t / 2, 0); fRm.rotation.y = Math.PI; fR.add(fRm);

  // Klebeband-Laschen an den Seiten (das Band läuft über den Deckel und knickt seitlich ab)
  const tabGeo = new THREE.PlaneGeometry(0.11, 0.11);
  const tabL = new THREE.Mesh(tabGeo, mTape); tabL.rotation.y = -Math.PI / 2; tabL.position.set(-W / 2 - 0.0016, H - 0.055, 0); box.add(tabL);
  const tabR = new THREE.Mesh(tabGeo, mTape); tabR.rotation.y = Math.PI / 2; tabR.position.set(W / 2 + 0.0016, H - 0.055, 0); box.add(tabR);

  /* ---------- Licht aus der Box ---------- */
  // Licht wird nur aufaddiert; der Alphakanal bleibt unberührt, damit die Seite dahinter sichtbar bleibt
  const glowBlend = (m) => Object.assign(m, {
    blending: THREE.CustomBlending, blendEquation: THREE.AddEquation,
    blendSrc: THREE.SrcAlphaFactor, blendDst: THREE.OneFactor,
    blendSrcAlpha: THREE.ZeroFactor, blendDstAlpha: THREE.OneFactor,
    transparent: true, depthWrite: false,
  });
  const radial = (stops, size = 256) => {
    const [c, g] = canvas2d(size, size);
    const gr = g.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
    stops.forEach(([o, col]) => gr.addColorStop(o, col));
    g.fillStyle = gr; g.fillRect(0, 0, size, size);
    return tex(c);
  };
  const glowTex = radial([[0, 'rgba(255,255,255,1)'], [0.25, 'rgba(255,226,150,.95)'], [0.6, 'rgba(255,170,60,.45)'], [1, 'rgba(255,140,40,0)']]);
  const dotTex = radial([[0, 'rgba(255,255,255,1)'], [0.35, 'rgba(255,220,140,.9)'], [1, 'rgba(255,170,60,0)']], 64);
  const shadowTex = radial([[0, 'rgba(0,0,0,.85)'], [0.55, 'rgba(0,0,0,.45)'], [1, 'rgba(0,0,0,0)']]);

  const innerGlow = new THREE.Mesh(new THREE.PlaneGeometry(W - 3 * t, D - 3 * t),
    glowBlend(new THREE.MeshBasicMaterial({ map: glowTex, color: 0xffd27a, opacity: 0 })));
  innerGlow.rotation.x = -Math.PI / 2; innerGlow.position.y = H * 0.6; box.add(innerGlow);

  const pLight = new THREE.PointLight(0xffc46b, 0, 0, 1.0); pLight.position.set(0, H * 0.3, 0); box.add(pLight);

  const coneMat = glowBlend(new THREE.ShaderMaterial({
    uniforms: { uI: { value: 0 }, uT: { value: 0 }, uC: { value: new THREE.Color(0xffc266) } },
    vertexShader: `varying vec2 vUv; varying vec3 vN; varying vec3 vV;
      void main(){ vUv = uv; vec4 mv = modelViewMatrix * vec4(position,1.0); vN = normalize(normalMatrix * normal); vV = normalize(-mv.xyz); gl_Position = projectionMatrix * mv; }`,
    fragmentShader: `uniform float uI; uniform float uT; uniform vec3 uC; varying vec2 vUv; varying vec3 vN; varying vec3 vV;
      void main(){
        float f = pow(abs(dot(normalize(vN), normalize(vV))), 2.2);
        float fade = (1.0 - smoothstep(0.0, 1.0, vUv.y)) * smoothstep(0.0, 0.22, vUv.y);
        float rays = 0.72 + 0.28 * sin(vUv.x * 43.0 + uT * 0.9) * sin(vUv.x * 19.0 - uT * 0.6);
        gl_FragColor = vec4(uC * f * fade * rays * uI, 1.0);
      }`,
    side: THREE.DoubleSide,
  }));
  // Der Kegel beginnt an der Öffnung und wird ohne Tiefentest gezeichnet, damit die Klappen keine Kanten hineinschneiden
  coneMat.depthTest = false;
  const coneGeo = new THREE.CylinderGeometry(1.05, 0.46, 2.2, 56, 1, true); coneGeo.translate(0, 1.1, 0);
  const cone = new THREE.Mesh(coneGeo, coneMat); cone.position.y = H - 0.02; cone.renderOrder = 10; box.add(cone);

  const bloom = new THREE.Sprite(glowBlend(new THREE.SpriteMaterial({ map: glowTex, color: 0xffc56a, opacity: 0 })));
  bloom.position.set(0, H + 0.2, 0); bloom.scale.set(2.6, 2.0, 1); box.add(bloom);

  const N = small ? 60 : 180;
  const pos = new Float32Array(N * 3), base = new Float32Array(N * 3), spd = new Float32Array(N);
  const seed = (i, y) => {
    base[i * 3] = (Math.random() - 0.5) * 0.78; base[i * 3 + 2] = (Math.random() - 0.5) * 0.7;
    base[i * 3 + 1] = y; spd[i] = 0.18 + Math.random() * 0.42;
  };
  for (let i = 0; i < N; i++) seed(i, Math.random() * 2.2);
  const pGeo = new THREE.BufferGeometry(); pGeo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
  const pMat = glowBlend(new THREE.PointsMaterial({ map: dotTex, color: 0xffd58a, size: small ? 0.05 : 0.04, opacity: 0, sizeAttenuation: true }));
  const sparks = new THREE.Points(pGeo, pMat); sparks.position.y = H * 0.6; sparks.frustumCulled = false; box.add(sparks);

  const shadow = new THREE.Mesh(new THREE.PlaneGeometry(2.3, 1.9), new THREE.MeshBasicMaterial({ map: shadowTex, transparent: true, depthWrite: false, opacity: 0.85 }));
  shadow.rotation.x = -Math.PI / 2; shadow.position.y = 0.002; rig.add(shadow);

  /* ---------- Zustand (vom Scrollen gesteuert) ---------- */
  const S = { rot: -0.5, shake: 0, maj: 0, min: 0, light: 0, elev: 0.13, dist: 1, lift: 0 };
  const I = { drop: reduce ? 0 : 1 };
  const P = { x: 0, y: 0, tx: 0, ty: 0 };

  const dpr = () => Math.min(window.devicePixelRatio || 1, 2);
  let vw = 1, vh = 1;
  function resize() {
    const r = stage.getBoundingClientRect();
    vw = Math.max(1, Math.round(r.width)); vh = Math.max(1, Math.round(r.height));
    renderer.setPixelRatio(dpr());
    renderer.setSize(vw, vh, false);
    camera.aspect = vw / vh; camera.updateProjectionMatrix();
  }
  resize();
  new ResizeObserver(() => { resize(); if (reduce) draw(0, 0); }).observe(stage);

  const target = new THREE.Vector3();
  const tan = Math.tan(THREE.MathUtils.degToRad(camera.fov / 2));
  function draw(dt, time) {
    const float = reduce ? 0 : Math.sin(time * 1.15) * 0.022 * (1 - S.light * 0.4);
    box.position.y = I.drop * 1.9 + float;
    box.rotation.y = S.rot + I.drop * 1.5 + P.x * 0.16;
    box.rotation.z = Math.sin(time * 41) * 0.022 * S.shake;
    box.rotation.x = Math.sin(time * 33) * 0.014 * S.shake;
    fF.rotation.x = S.maj * 2.18;
    fB.rotation.x = -S.maj * 2.02;
    fL.rotation.z = S.min * 1.92;
    fR.rotation.z = -S.min * 1.98;
    const L1 = Math.max(0, S.light);
    innerGlow.material.opacity = Math.min(1, L1 * 1.15);
    pLight.intensity = L1 * 2.2;
    coneMat.uniforms.uI.value = L1 * 0.8;
    coneMat.uniforms.uT.value = time;
    cone.scale.set(0.85 + L1 * 0.15, 0.4 + L1 * 0.6, 0.85 + L1 * 0.15);
    bloom.material.opacity = L1 * 0.6;
    pMat.opacity = Math.min(1, L1 * 1.2);
    if (L1 > 0.01 && !reduce) {
      for (let i = 0; i < N; i++) {
        let y = base[i * 3 + 1] + spd[i] * dt * (0.5 + L1);
        if (y > 2.3) { seed(i, 0); y = 0; }
        base[i * 3 + 1] = y;
        const spread = 1 + y * 0.42;
        pos[i * 3] = base[i * 3] * spread + Math.sin(time * 1.3 + i) * 0.02;
        pos[i * 3 + 1] = y;
        pos[i * 3 + 2] = base[i * 3 + 2] * spread;
      }
      pGeo.attributes.position.needsUpdate = true;
    }
    shadow.material.opacity = 0.85 * (1 - Math.min(1, I.drop * 1.2));
    shadow.scale.setScalar(1 + I.drop * 0.6);
    // Kamera: so weit weg, dass die offene Box sicher ins Bild passt
    const aspect = vw / vh;
    const needH = 2.35, needW = small ? 1.95 : 2.2;
    const dist = Math.max(needH / (2 * tan), needW / (2 * tan * aspect)) * S.dist;
    const az = P.x * 0.1;
    target.set(0, H * 0.5 + S.lift, 0);
    camera.position.set(
      target.x + Math.sin(az) * Math.cos(S.elev) * dist,
      target.y + Math.sin(S.elev) * dist + P.y * 0.08,
      target.z + Math.cos(az) * Math.cos(S.elev) * dist
    );
    camera.lookAt(target);
    renderer.render(scene, camera);
  }

  /* ---------- Bewegung ---------- */
  const ok = await waitForGsap();
  const gsap = window.gsap, ST = window.ScrollTrigger;

  if (reduce || !ok) {
    Object.assign(S, { rot: -0.3, maj: 1, min: 1, light: 1, elev: 0.5, dist: 0.95, lift: 0.08 });
    root.classList.add('is-ready', 'is-static');
    draw(0, 0);
    return;
  }
  gsap.registerPlugin(ST);
  ST.config({ ignoreMobileResize: true });

  const pin = small ? 1.6 : 2.1;
  const tl = gsap.timeline({
    defaults: { ease: 'none' },
    scrollTrigger: {
      trigger: stage,
      start: () => 'top top+=' + offset,
      end: () => '+=' + Math.round(window.innerHeight * pin),
      pin: true, scrub: small ? 0.3 : 0.8, anticipatePin: 1, invalidateOnRefresh: true,
      onRefreshInit: () => { offset = headerOffset(); root.style.setProperty('--mmb3d-offset', offset + 'px'); },
    },
  });
  tl.to(S, { rot: 0.62, ease: 'power1.inOut', duration: 4.4 }, 0)
    .to(cue, { autoAlpha: 0, duration: 0.6 }, 0.2)
    .to(S, { shake: 1, duration: 0.5 }, 2.2)
    .to(S, { shake: 0, duration: 0.4 }, 2.75)
    .to(S, { maj: 1, ease: 'back.out(1.5)', duration: 2.2 }, 2.95)
    .to(S, { min: 1, ease: 'back.out(1.3)', duration: 2.0 }, 3.9)
    .to(S, { light: 1, ease: 'power2.out', duration: 3.4 }, 3.3)
    .to(S, { rot: -0.28, ease: 'power2.inOut', duration: 4.2 }, 4.4)
    .to(S, { elev: 0.56, dist: 0.93, lift: 0.1, ease: 'power2.inOut', duration: 4.8 }, 4.4)
    .to(wordA, { autoAlpha: 0, yPercent: -18, ease: 'power2.in', duration: 1.2 }, 3.8)
    .fromTo(wordB, { autoAlpha: 0, yPercent: 18 }, { autoAlpha: 1, yPercent: 0, ease: 'power2.out', duration: 1.4 }, 4.8)
    .fromTo(end, { autoAlpha: 0, y: 18 }, { autoAlpha: 1, y: 0, ease: 'power2.out', duration: 1.4 }, 7.4)
    .to({}, { duration: 1.2 });

  if (finePointer) {
    stage.addEventListener('pointermove', (e) => {
      const r = stage.getBoundingClientRect();
      P.tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      P.ty = ((e.clientY - r.top) / r.height - 0.5) * -2;
    }, { passive: true });
    stage.addEventListener('pointerleave', () => { P.tx = 0; P.ty = 0; });
  }

  let visible = true;
  new IntersectionObserver((en) => { visible = en[0].isIntersecting; }, { rootMargin: '100px' }).observe(stage);

  let last = performance.now(), frame = 0;
  renderer.setAnimationLoop((now) => {
    if (!visible || document.hidden) return;
    if (small && (frame++ & 1)) return; // am Handy 30 Bilder/s, halbe Last
    const dt = Math.min(0.08, (now - last) / 1000); last = now;
    P.x += (P.tx - P.x) * 0.06; P.y += (P.ty - P.y) * 0.06;
    draw(dt, now / 1000);
  });

  // Auftritt: die Box fällt herein
  root.classList.add('is-ready');
  gsap.to(I, { drop: 0, duration: small ? 1.0 : 1.5, ease: small ? 'power2.out' : 'bounce.out', delay: 0.15 });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => ST.refresh());
}

function start() {
  document.querySelectorAll('[data-mmb3d]').forEach((el) => {
    if (el.dataset.mmb3dBooted) return;
    el.dataset.mmb3dBooted = '1';
    boot(el).catch(() => el.classList.add('is-fallback', 'is-static'));
  });
}
start();
document.addEventListener('shopify:section:load', start);
